if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.requiresVariantSelection && !this.variantIdInput.value) {
          this.handleErrorMessage(window.variantStrings?.selectRequired || 'Please select an option before adding this item to your cart.');
          this.closest('product-info')?.querySelector('variant-selects')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const productInfo = this.closest('product-info') || document;
        const selectedAddonInputs = Array.from(productInfo.querySelectorAll('[data-product-addons] [data-ars-addon-id]:checked'));
        const selectedAddonIds = selectedAddonInputs.map((input) => Number(input.value)).filter(Boolean);
        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
        if (this.cart) this.cart.setActiveElement(document.activeElement);

        const addGiftOptions = selectedAddonIds.length
          ? fetch(`${routes.cart_add_url}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: selectedAddonIds.map((id) => ({ id, quantity: 1 })) }),
            }).then((response) => response.json().then((data) => ({ ok: response.ok, data }))).then(({ ok, data }) => {
              if (!ok || data.status) throw new Error(data.description || data.message || 'Unable to add gift options.');
              selectedAddonInputs.forEach((input) => { input.checked = false; });
            })
          : Promise.resolve();

        addGiftOptions
          .then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.errors || response.description, message: response.message });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response }).then(() => { CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker); });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => { setTimeout(() => { CartPerformance.measure('add:paint-updated-sections', () => { this.cart.renderContents(response); }); }); }, { once: true });
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => { this.cart.renderContents(response); });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(e.message || 'Something went wrong. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessage.style.color =
            errorMessage === 'Please select an option before adding this item to your cart.' ? '#EB001B' : '';
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get requiresVariantSelection() {
        return this.form.dataset.requiresVariantSelection === 'true';
      }

      get variantIdInput() { return this.form.querySelector('[name=id]'); }
    }
  );
}
